import React from 'react';
import Pagination from 'rc-pagination';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import messages from '../../locale/messages';
import n from 'rc-pagination/assets/index.css';
import s from '../../styles/pagination.css';

const CustomPagination = ({
  total,
  defaultCurrent,
  defaultPageSize,
  currentPage,
  change,
  intl: { formatMessage },
  paginationLabel = 'items'
}) => {

  const handleChange = (currentPage) => {
    change(currentPage);
  };

  const renderShowTotal = (total, range) => {
    return (
      <div className={'resultsCount'}>
        <span>{range[0]}</span>
        <span>&nbsp;–&nbsp;</span>
        <span>{range[1]}</span>
        <span className="displayinlineRTL">&nbsp;{formatMessage(messages.ofLabel)}&nbsp;</span>
        <span className="displayinlineRTL">{total}</span>
        <span>&nbsp;{paginationLabel}</span>
      </div>
    );
  };

  return (
    <div className={'position-relative'}>
      <Pagination
        className="ant-pagination"
        defaultCurrent={defaultCurrent}
        current={currentPage}
        total={total}
        defaultPageSize={defaultPageSize}
        onChange={handleChange}
        showTotal={renderShowTotal}
        showLessItems
        locale={"en_US"}
        prevIcon={<span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 16 16" fill='currentColor'>
            <path d="M11.4,15.5c-0.2,0-0.3-0.1-0.5-0.2L4.1,8.5c-0.3-0.3-0.3-0.7,0-1l6.8-6.8c0.3-0.3,0.7-0.3,1,0  s0.3,0.7,0,1L5.6,8l6.3,6.3c0.3,0.3,0.3,0.7,0,1C11.8,15.4,11.6,15.5,11.4,15.5L11.4,15.5z" />
          </svg>
        </span>}
        nextIcon={<span>
          <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 16 16" fill='currentColor'>
            <path d="M4.6,15.5c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1L10.4,8L4.1,1.7c-0.3-0.3-0.3-0.7,0-1  s0.7-0.3,1,0l6.8,6.8c0.3,0.3,0.3,0.7,0,1l-6.8,6.8C4.9,15.4,4.8,15.5,4.6,15.5L4.6,15.5z" />
          </svg>
        </span>}
        jumpPrevIcon={
          <span className='rc-pagination-jump-custom-icon'>
            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
            <span className='rc-pagination-jump-afterHover-icon'>&#8249;&#8249;</span>
          </span>
        }
        jumpNextIcon={
          <span className='rc-pagination-jump-custom-icon'>
            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
            <span className='rc-pagination-jump-afterHover-icon'>&#8250;&#8250;</span>
          </span>
        }
        align={"center"}
      />
    </div>
  );
};

export default injectIntl(withStyles(n, s)(CustomPagination));
